import { cache } from '@/container/apollo-client/cache';
import { WorkspaceMemberCountItem, WorkspaceMembers } from '@/types/generated/graphql';

export function cacheUpdateMemberRole(node: WorkspaceMembers) {
  try {
    cache.modify({
      id: cache.identify({ id: node?.id, __typename: 'WorkspaceMembers' }),
      fields: {
        roles: (existingRoles) => [{ ...existingRoles?.[0], label: node?.roles?.[0]?.label }],
      },
    });
  } catch (error) {
    console.error('Error updating member in cache: ', error);
  }
}

export function cacheDeleteMember(nodeId: number) {
  try {
    const normalizedId = cache.identify({ id: nodeId, __typename: 'WorkspaceMembers' });
    cache.evict({ id: normalizedId });
    cache.gc();
  } catch (error) {
    console.error('Error deleting member in cache: ', error);
  }
}

export function invalidateMyNumbersChannelsCache() {
  try {
    cache.modify({
      fields: {
        channelsV2: () => {},
      },
    });
  } catch (error) {
    console.error('Error invalidating channelsV2 cache: ', error);
  }
}

export function incrementTotalMemberCountInCache() {
  cache.modify({
    fields: {
      countMembers(existing) {
        if (!existing?.data) return existing;
        return {
          ...existing,
          data: existing?.data?.map((item: WorkspaceMemberCountItem) => {
            if (item?.key === 'total') {
              return {
                ...item,
                value: (item.value || 0) + 1,
              };
            }
            return item;
          }),
        };
      },
    },
  });
}

// ? Temporary fix
// export function decreaseTotalMemberCountInCache() {
//   cache.modify({
//     fields: {
//       countMembers(existing) {
//         if (!existing?.data) return existing;
//         return {
//           ...existing,
//           data: existing?.data?.map((item: WorkspaceMemberCountItem) => {
//             if (item?.key === 'total') {
//               return {
//                 ...item,
//                 value: (item.value || 0) - 1,
//               };
//             }
//             return item;
//           }),
//         };
//       },
//     },
//   });
// }

export function decreaseTotalMemberCountInCache() {
  cache.evict({ fieldName: 'countMembers' });
  cache.gc();
}
